module.exports = __webpack_public_path__ + "static/media/substrate.09e15319.png";